export const ApiDef_InstallationFlowsheetConfiguration = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map